import { Routes, Route } from 'react-router-dom';
import { useState } from 'react';
import Home from './views/Home';
import Version from './views/Version';
import Formation from './views/Formation';
import ErrorPage from './views/ErrorPage';
import RedirectToLesson from './services/RedirectToLesson';
import UserProfile from './views/profile/UserProfile';
import { GettingStartedModal } from './views/GettingStarted';
import { Header } from './views/Header';
import './services/i18n';
import { useUserContext, UserContext } from './contexts/userContext';
import { TailSpin } from 'react-loader-spinner';

function App() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { regions } = useUserContext() as UserContext;
    return regions.length ? (
        <>
            <Routes>
                <Route path="/" element={<Header setIsModalOpen={setIsModalOpen} />}>
                    <Route index element={<Home isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />} />
                    <Route path="profile" element={<UserProfile />} />
                    <Route path="formation/:formationId" element={<Formation />} />
                    <Route path="formation/:formationId/version/:versionId" element={<RedirectToLesson />} />

                    <Route path="formation/:formationId/version/:versionId/lesson/:lessonId" element={<Version />} />
                </Route>

                <Route path="formation/:formationId/version/:versionId/steps_check" element={<Version />}>
                    <Route path="*" element={<ErrorPage />} />
                </Route>
            </Routes>
            <GettingStartedModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        </>
    ) : (
        <div className="flex h-screen w-full items-center justify-center">
            <TailSpin
                visible={true}
                height="40"
                width="40"
                color="#293C64"
                ariaLabel="tail-spin-loading"
                radius="1"
                wrapperStyle={{}}
                wrapperClass="pr-5"
            />
        </div>
    );
}

export default App;
